// extracted by mini-css-extract-plugin
export default {"emojiBackground":"EmojiBadge_emojiBackground__3q7yw","emoji":"EmojiBadge_emoji__b2r7R","count":"EmojiBadge_count__BwPdJ"};